// Colors map to the SHIFTIN brand palette per the brand guidelines
// (vibrant purple, energetic pink, bright turquoise, striking orange).
// SHIFTIN gets the primary brand purple; the other entities each get one
// of the remaining brand colors so all four vibrant brand colors are used.
export const ENTITIES = [
    { id: 'shiftin', name: 'SHIFTIN', short: 'SHF', color: '#7037ef', email: 'rh@shiftin.co' },
    { id: 'octera', name: 'Octera', short: 'OCT', color: '#0bdbd1', email: 'rh@octera.dz' },
    { id: 'shiftgrp_alger', name: 'SHIFT GROUP Algiers', short: 'SGA', color: '#ff5e11', email: 'rh.alger@shiftgroup.dz' },
    { id: 'shiftgrp_annaba', name: 'SHIFT GROUP Annaba', short: 'SGN', color: '#e26cff', email: 'rh.annaba@shiftgroup.dz' },
];
export const ENTITY_BY_ID = Object.fromEntries(ENTITIES.map((e) => [e.id, e]));
export const DEFAULT_ENTITY_ID = 'shiftin';
//# sourceMappingURL=entities.js.map